export enum ScreenSize {
	xs = 'xs',
	sm = 'sm',
	md = 'md',
	lg = 'lg',
}

export const ScreenSizeBreakpoints = {
	[ScreenSize.xs]: 0,
	[ScreenSize.sm]: 409,
	[ScreenSize.md]: 768,
	[ScreenSize.lg]: 1024,
}

export interface Size {
	width: number
	height: number
}

export interface KRPanoImageFOV {
	h: number
	v: number
}

export interface ImageSize {
	w: number
	h: number
}

export interface KRPanoCoords {
	ath: number
	atv: number
}

export interface XYCoords {
	x: number
	y: number
}

/**
 * Use preset to reduce the amount of requests Bunny sends to S3
 */
export enum ImageSizePreset {
	Thumbnail = 'thumbnail',
	Grid = 'grid',
	Row = 'row',
	Fullscreen = 'fullscreen',
}

export const ImageSizePresetMap: Record<ImageSizePreset, { width: number, height: number, crop: boolean }> = {
	[ImageSizePreset.Thumbnail]: { width: 64, height: 64, crop: true },
	[ImageSizePreset.Grid]: { width: 200, height: 200, crop: true },
	[ImageSizePreset.Row]: { width: 1000, height: 750, crop: false },
	// TODO: ideally this should be evaluated dynamically, not just on page load
	[ImageSizePreset.Fullscreen]: window.innerWidth < 1000 ?
		{ width: 540, height: 960, crop: true } :
		{ width: 1920, height: 1080, crop: true }
}
